<template>
  <div >
    <div class="zs" id="zs">
      <meta content="width=device-width,maximum-scale=1" name="viewport" />
      <img src="../../assets/images/zs3.png" alt="背景色" class="bg" style="width: 755px; height: 1067px"/>

      <img src="../../assets/images/zhang1.png" alt="章" class="zs_bone" style="width: 152px;height: 149px;"/>
      <div class="zs_num">
     <!-- <div style="width: 100px !important;display: inline-block;">学号 :</div>    <span>{{ dataMsg.studyNo }}</span> -->
      </div>
            <h1 style="font-size: 28px">铜仁学院省级专业技术人员继续教育培训证书</h1>
   <div class="content1">
            <div class="contentInfo">
              <div class="avater">
                <img :src="dataMsg.userPhoto" alt="头像" />
              </div>
              <div class="infotext">
                <div style="display: flex; align-items: center; margin-bottom: 24px; height: 28px">
                  <div class="text_1">姓&emsp;&emsp;名 ：</div>
                  <div class="text_2">{{ dataMsg.realname || '' }}</div>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 24px; height: 28px">
                  <div class="text_1">身份证号 ：</div>
                  <div class="text_2">{{ dataMsg.cardno || '' }}</div>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 24px; height: 28px">
                  <div class="text_1">培训形式：</div>
                  <div class="text_2">{{ dataMsg.trainType=='01'?'半脱产':dataMsg.trainType=='02'?'脱产':dataMsg.trainType=='03'?'网络':'' }}</div>
                </div>
                <div style="display: flex; align-items: center; margin-bottom: 24px; height: 28px">
                  <div class="text_1">证书编号：</div>
                  <div class="text_2">{{ dataMsg.certNo || '' }}</div>
                </div>
              </div>
            </div>
            <div class="group_1">
              &emsp;&emsp;<span class="underline">{{ dataMsg.realname || '' }}</span
              ><span class="text_3">同志参加专业技术人员继续教育，</span> <span class="underline">{{ dataMsg.className || '' }}</span
              ><span class="text_3">累计完成</span><span class="underline">{{ Math.ceil(dataMsg.creditSum) || '' }}</span>
              <span class="text_3">学时，经考核合格，根据专业技术人员继续教育有关规定，特发此证。</span>
            </div>
          </div>
      <!-- <table class="table1">
        <tbody>
          <tr>
            <td class="td1" style="width: 94px; height: 42px">姓  名</td>
            <td class="td1" style="width: 106px">{{ dataMsg.realname }}</td>
            <td class="td1" style="width: 104px">身份证号</td>
            <td class="td2" style="width: 227px">{{ dataMsg.cardno }}</td>

            <td rowspan="3" class="td2">
              <img
                :src="dataMsg.userPhoto"
                alt="头像"
                style="width: 90px; height: 128px; margin-top: 1px"
                v-show="dataMsg.userPhoto != null"
              />
              <img
                src="../../assets/new/02_03.png"
                alt="头像"
                style="width: 90px; height: 128px; margin-top: 1px"
                v-show="dataMsg.userPhoto == null"
              />
            </td>
          </tr>
          <tr>
            <td class="td1" style="width: 94px; height: 54px">性  别</td>
            <td class="td1" style="width: 106px" v-show="dataMsg.sex == '01'">男</td>
            <td class="td1" style="width: 106px" v-show="dataMsg.sex == '02'">女</td>
            <td class="td1" style="width: 106px" v-show="dataMsg.sex == null"></td>

            <td class="td1" style="width: 104px">工作单位</td>
            <td class="td2" style="width: 227px">
              <p>{{ dataMsg.organization }}</p>
            </td>
          </tr>
          <tr>
            <td colspan="5" style="height: 36px"><span class="zs_qk">接 受 继 续 教 育 情 况</span></td>
          </tr>
        </tbody>
      </table> -->

      <!-- <ul>
        <li style="width: 202px; height: 37px; line-height: 37px" class="li1">继续教育项目名称</li>
        <li style="width: 422px; height: 37px; line-height: 37px" class="li2">{{ dataMsg.className }}</li>
        <li style="width: 94px; height: 40px; line-height: 40px" class="li1">主办单位</li>
        <li style="width: 210px; height: 40px; line-height: 40px" class="li1">安徽冠成教育科技有限公司</li>
        <li style="width: 94px; height: 40px; line-height: 40px" class="li1">学习形式</li>
        <li style="width: 226px; height: 40px; line-height: 40px" class="li2">在线学习</li>
        <li style="width: 94px; height: 40px; line-height: 40px" class="li1">培训时间</li>
        <li style="width: 210px; height: 40px; line-height: 40px" class="li1">
          {{ dataMsg.startYear }}年{{ dataMsg.startMonth }}月-{{ dataMsg.endYear }}年{{ dataMsg.endMonth }}月
        </li>
        <li style="width: 94px; height: 40px; line-height: 40px" class="li1">总学时数</li>
        <li style="width: 226px; height: 40px; line-height: 40px" class="li2">{{ dataMsg.creditSum }}</li>
      </ul> -->
      <!-- <table class="table2">
        <thead>
          <tr>
            <td style="width: 201px; height: 47px" class="td1">学习课程</td>
            <td style="width: 37px" class="td1">学时</td>
            <td style="width: 64px" class="td1">评定结果</td>
            <td style="width: 212px" class="td1">学习课程</td>
            <td style="width: 37px" class="td1">学时</td>
            <td style="width: 68px" class="td2">评定结果</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="i in zsList.length / 2">
            <td class="td1" height="38px" v-show="zsList[2 * i - 2].courseName != null && zsList[2 * i - 2].courseName != ''">
              <p>{{ zsList[2 * i - 2].courseName }}</p>
            </td>
            <td class="td1" v-show="zsList[2 * i - 2].credit != null && zsList[2 * i - 2].credit != ''">{{ zsList[2 * i - 2].credit }}</td>
            <td class="td1" v-show="zsList[2 * i - 2].courseName != ''">合格</td>

            <td class="td1" height="38px" v-show="zsList[2 * i - 1].courseName != null && zsList[2 * i - 1].courseName != ''">
              <p>{{ zsList[2 * i - 1].courseName }}</p>
            </td>
            <td class="td1" v-show="zsList[2 * i - 1].credit != null && zsList[2 * i - 1].credit != ''">{{ zsList[2 * i - 1].credit }}</td>
            <td class="td1" v-show="zsList[2 * i - 1].courseName != ''">合格</td>
          </tr>
        </tbody>
      </table> -->

      <p class="zs_z">培训单位（盖章）</p>

      <p class="zs_date">
        <span>{{ dataMsg.createYear }}</span
        >年<span>{{ dataMsg.createMonth }}</span
        >月<span>{{ dataMsg.createDay }}</span
        >日
      </p>

        <div id="ewm" style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
          <img :src="dataMsg.imageEwm" alt="二维码" width="120" height="120" class="left" />
          <p class="left" style="margin-top: 11px;">扫描查验证书</p>
        </div>
     
    </div>

    <a
      @click="backPrev"
      style="
        height: 60px;
        float: left;
        background: #48a5cf;
        color: #fff;
        border-radius: 4px;
        line-height: 60px;
        text-align: center;
        width: 711px;
        margin: 30px 0 30px 20px;
        font-size: 36px;
        outline: none;
        text-decoration: none;
      "
      >返回</a
    >
  </div>
</template>
<script>
import { getCertDetail } from '../../api/certificate';
export default {
  data() {
    return {
      dataMsg: {},
      zsList: [] //证书数据
    };
  },
  created() {
    // 获取证书唯一id
    var idNum = this.$route.query.certId;
    var params = { certId: idNum };
    getCertDetail(params).then(res => {
      this.dataMsg = res.data.data;
      // 将证书信息转为数组存起来
      var len = this.dataMsg.creditList.length;
      var falsedata = { credit: '', courseName: '' };
      for (var i = 0; i < 18; i++) {
        if (i < len) {
          this.zsList.push(this.dataMsg.creditList[i]);
        } else {
          this.zsList.push(falsedata);
        }
      }
    });
  },
  methods: {
    backPrev() {
      //返回按钮
      this.$router.go(-1);
    }
  }
};
</script>
<style scoped lang="less">
table {
  border-collapse: collapse;
  border-spacing: 0;
}
#ewm {
  position: absolute;
  bottom: 65px;
  left: 100px;
  border: 1px solid #bbb;
  padding: 3px 10px;
  display: flex;
}
#ewm p {
  margin: 12px 0 0 10px;
}
.zs {
font-size: 12px;
  color: #000000;
  width: 751px;
  height: 1061px;
  margin: 0 auto;
  padding: 88px 80px 64px 80px;
  position: relative;
}
.zs .bg {
  position: absolute;
  top: 0;
  left: 0;
  z-index: -10;
}
.zs .zs_bone {
  position: absolute;
  bottom: 65px;
  left: 504px;
  right: 0px;
}
.zs .zs_num {
  /* padding-left: 420px; */
  margin-left: 380px;
  width: 200px;
  display: flex;
}
.zs h1 {
  margin-top: 15px;
  text-align: center;
  font-size: 25px;
  font-weight: 600;
}
.zs .table1 {
  width: 624px;
  border: 2px solid #b2b2b2;
  border-left: none;
  border-right: none;
  margin-top: 20px;
}
.zs .table1 tr td {
  text-align: center;
}
.zs .table1 tr td .zs_qk {
  font-size: 25px;
}
.zs .table1 tr td p {
  text-align: left;
  padding-left: 10px;
}
.zs .table1 tr .td1 {
  border-right: 2px solid #b2b2b2;
  border-bottom: 2px solid #b2b2b2;
}
.zs .table1 tr .td2 {
  border-bottom: 2px solid #b2b2b2;
}
.zs ul {
  width: 624px;
  overflow: hidden;
}
.zs ul li {
  float: left;
  text-align: center;
}
.zs ul .li1 {
  border-right: 2px solid #b2b2b2;
  border-bottom: 2px solid #b2b2b2;
}
.zs ul .li2 {
  border-bottom: 2px solid #b2b2b2;
}
.zs .table2 {
  width: 624px;
}
.zs .table2 tr td {
  text-align: center;
  padding: 3px 0;
}
.zs .table2 tr td p {
  padding: 0 12px;
  text-align: left;
}
.zs .table2 tr .td1 {
  border-right: 2px solid #b2b2b2;
  border-bottom: 2px solid #b2b2b2;
}
.zs .table2 tr .td2 {
  border-bottom: 2px solid #b2b2b2;
}
.zs .zs_z {
  padding-left: 300px;
  margin-top: 20px;
  position: absolute;
  top: 910px;
  left: 232px;
  width: 420px;
}
.zs .zs_date {
  padding-left: 325px;
  margin-top: 20px;
  position: absolute;
  top: 950px;
  left: 180px;
  display: flex;
}
.zs .zs_date span {
  display: inline-block;
  margin: 0 7px;
}
.content1 {
  margin-top: 50px;
  .contentInfo {
    display: flex;

    .avater {
      margin-right: 19px;
      img {
        width: 128px;
        height: 182px;
        background: #e8e8e8;
        border-radius: 0px 0px 0px 0px;
      }
    }
    .text_1 {
      font-family: Kaiti SC, Kaiti SC;
      font-weight: 900;
      font-size: 20px;
      color: #000000;
      line-height: 50px;
    }
    .text_2 {
      font-family: Kaiti SC, Kaiti SC;
      font-weight: 400;
      font-size: 20px;
      color: #333333;
    }
  }
  .group_1 {
    margin-top: 63px;
    .underline {
      height: 57px;
      text-decoration: underline;
      font-family: Kaiti SC, Kaiti SC;
      font-weight: 400;
      font-size: 20px;
      color: #000000;
      line-height: 45px;
      // letter-spacing: 15px;
      text-align: center;
    }
    .text_3 {
      font-family: Kaiti SC, Kaiti SC;
      font-weight: 900;
      font-size: 20px;
      color: #000000;
      letter-spacing:9px;
      line-height: 57px;
    }
  }
}
</style>
